import type { Faq } from '../types/content';

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Diesel technicians, mechanics, workshop owners, and learners who want a structured, visual reference to support their diagnostic work.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. Diesel Fault Atlas is a digital reference collection. No physical books or diagnostic equipment are shipped.',
  },
  {
    question: 'Is this a training course or certification?',
    answer: 'No. It is a reference collection for everyday diagnostic work. It is not a course, and it does not provide a certification or credential.',
  },
  {
    question: 'Is it another theory-heavy ebook?',
    answer:
      'The collection emphasizes visual references — system diagrams, workflows, testing sequences, decision trees, checklists, and worksheets — rather than long chapters of theory.',
  },
  {
    question: 'What areas are included?',
    answer:
      'Six volumes covering diagnostic workflow, fuel systems and common rail, air intake and boost, electrical systems, emissions and aftertreatment, and advanced fault cases — plus five supporting bonus resources.',
  },
  {
    question: 'Does this replace professional procedures or manufacturer instructions?',
    answer:
      'No. Manufacturer-specific procedures, specifications, and safety information remain necessary. Use the collection alongside the service documentation for the vehicle or engine being tested.',
  },
  {
    question: 'How will I receive it?',
    answer: '',
    commercial: 'delivery',
  },
  {
    question: 'Does it work for light-duty, heavy-duty, and agricultural diesel engines?',
    answer:
      'The diagnostic principles and system areas apply across many diesel applications, but the collection is not a model-specific manual. Whether a given procedure applies depends on the vehicle, engine, and system — always confirm in the manufacturer’s documentation.',
  },
  {
    question: 'Do I need a specific scan tool or expensive equipment?',
    answer:
      'No specific brand is required. Some checks call for a suitable scan tool, multimeter, or other measuring equipment, depending on the test and the manufacturer’s procedure. Diagnostic equipment is not included.',
  },
  {
    question: 'Is it a one-time payment, and how does the refund work?',
    answer: '',
    commercial: 'payment',
  },
];
